import { API } from '../helpers/fetcher'

export const authorise = async params =>
  API.post('v1/transaction/card/authorise', params)

/**
 * Exchange the Evervault-encrypted card (`ev:` values from the <Card> iframe)
 * for the Apexx `cardEncryptedData` token + BIN used by `authorise`.
 * @param {{ name: string, number: string, expiry: { month: string, year: string }, cvc: string }} card
 * @returns {Promise<{ responseData: { cardEncryptedData: string, cardBin: string }, responseStatus: number }>}
 */
export const reencryptCard = async card =>
  API.post('v1/transaction/card/reencrypt', card)

export const validateThreeDS = async cardinalJwt =>
  API.post('v1/transaction/card/validate-3ds/v2', {
    cardinalJwt,
  })

export const getTransactionDetails = async () =>
  API.get('v1/transaction/details')

export const checkPaymentStatus = async (paymentMethod, transactionId) =>
  API.get(`v1/transaction/${paymentMethod}/${transactionId}/status`)
